export const contactDetails = {
  address: 'B813, Segment2, Brigade Omega, Subramanyapura, Bangalore. 560061',
  phone: '+91 7676945797',
  email: 'ops@nhmarineglobal.com'
};
